class AudioPlayer {
    constructor(element) {
        this.element = element;

        this.isPlaying = false;
        this.isLoaded = false;

        this.playTrigger = this.element.querySelector('.js-audio-player-play-trigger');

        this.player = this.element.querySelector('.js-audio-player-src');
        this.playerProgress = this.element.querySelector('.js-audio-player-progress');

        this.timeLength = this.player.duration;
        this.playerProgress.setAttribute('data-duration', this.getTotalTimeString());

        this.currentTime = this.player.currentTime;

        this.playerProgressPercentage = 0;
        this.playerProgressBar = this.element.querySelector('.js-audio-player-progress-bar');

        this.initEvents();
    }

    initEvents() {
        this.playTrigger.addEventListener('click', () => {
            if (!this.isPlaying) {
                this.playAudio();
            } else {
                this.pauseAudio();
            }
        });

        this.player.addEventListener('timeupdate', () => {
            this.currentTime = this.player.currentTime;
            this.playerProgressPercentage = this.currentTime / this.timeLength * 100;
            this.playerProgressBar.style.width = `${this.playerProgressPercentage}%`;
            this.playerProgress.setAttribute('data-current-time', this.getCurrentTimeString());

            if (this.playerProgressPercentage === 100) {
                this.pauseAudio();
            }
        });
    }

    playAudio() {
        if (!this.isLoaded) {
            this.isLoaded = true;
        }

        this.player.play();
        this.isPlaying = true;
        this.playTrigger.classList.add('playing');
    }

    pauseAudio() {
        this.player.pause();
        this.isPlaying = false;
        this.playTrigger.classList.remove('playing');
    }

    getTotalTimeString() {
        const minutes = Math.floor(this.timeLength / 60);

        const secondsInt = this.timeLength - minutes * 60;
        const secondsStr = secondsInt.toString();
        const seconds = secondsStr.substr(0, 2);

        return `${minutes}:${seconds}`;
    }

    getCurrentTimeString() {
        const currentMinute = Math.floor(this.currentTime / 60);
        const currentSecondsLong = this.currentTime;
        const currentSeconds = currentSecondsLong.toFixed();

        // eslint-disable-next-line max-len
        return `${currentMinute < 10 ? `0${currentMinute}` : currentMinute}:${currentSeconds < 10 ? `0${currentSeconds}` : currentSeconds}`;
    }
}

const audioPlayer = {
    init() {
        const element = document.querySelector('.js-audio-player');

        if (!element) return;

        this.audioPlayer = new AudioPlayer(element);
    },
};

export default audioPlayer;
